import type { Organization } from '@/stores/session';
import type { OrganizationDto } from './types';

/** The session store's trimmed Organization, from the API's. The one place its
 *  defaults live — sign-in, onboarding and a settings save all go through it, so
 *  a new org setting can't reach one path and miss another. */
export const toSessionOrg = (o: OrganizationDto): Organization => ({
  id: o.id,
  name: o.name,
  slug: o.slug,
  base_currency: o.base_currency,
  logo: o.logo ?? null,
  primary_color: o.primary_color ?? '',
  default_commission_basis: o.default_commission_basis ?? 'first_client_invoice',
  manual_time_logging_enabled: o.manual_time_logging_enabled ?? true,
  timer_note_mode: o.timer_note_mode ?? 'optional',
});
